import { render, staticRenderFns } from "./SettingsMenuComponent.vue?vue&type=template&id=6f18cba9"
import script from "./SettingsMenuComponent.vue?vue&type=script&lang=js"
export * from "./SettingsMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports